import { AreaStatus, AreaType } from '@/constants/operator'

export const isAreaTypeFwa = (areaType: string) => {
  return areaType === AreaType.Fwa || areaType === AreaType.FwaLowband || areaType === AreaType.FwaSiteDevelopment
}

export const isAreaTypeUpsell = (areaType: string) => {
  return areaType === AreaType.Upsell
}

export const isAreaTypeChangeOperator = (areaTypeName: string) => areaTypeName === AreaType.UpsellOperatorChange

export const isAreaStatusUpsellOperatorChangeNoCampaign = (areaStatusName: string) => areaStatusName === AreaStatus.UpsellOperatorChangeNoCampaign

export const anslutningTypeText = (areaType: string) => {
  if (areaType === AreaType.Fwa || areaType === AreaType.FwaSiteDevelopment) {
    return 'Fast Bredband via mobilnätet'
  } else if (areaType === AreaType.FwaLowband) {
    return 'Fast Bredband via mobilnätet Bas'
  }
  return 'Fiber'
}
